export default "__VITE_ASSET__CyVV9UuI__"